module.exports = __webpack_public_path__ + "img/add-video.861217ef.svg";